import Splide from '@splidejs/splide';

export default {

	selectors: {
		splide: '.splide',
		progress: '.splide__progress-bar',
	},

	init() {
		if (!document.querySelectorAll(this.selectors.splide).length) return;
		const splide = new Splide(this.selectors.splide, {
			arrows: false,
			pagination: false,
			padding: {
				right: '15vw',
				left: '15vw',
			},
			breakpoints: {
				640: {
					padding: {
						right: '32px',
						left: '32px',
					},
				},
			},
		});
		this.progress = document.querySelector(this.selectors.progress);

		splide.on('mounted', () => {
			const percentage = (splide.index + 1) / splide.length * 100;
			this.progress.style.width = `${percentage}%`;
		});

		splide.on('click', (slide) => {
			splide.go(slide.index);
		});

		splide.on('move', (slide) => {
			const percentage = (slide + 1) / splide.length * 100;
			this.progress.style.width = `${percentage}%`;
		});

		splide.mount();
	},

};
